import { render, staticRenderFns } from "./OwnersRepresentativeInvite.vue?vue&type=template&id=60b56a73&"
import script from "./OwnersRepresentativeInvite.vue?vue&type=script&lang=js&"
export * from "./OwnersRepresentativeInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports